// import { Box, Button, Typography, Modal, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  DialogTitle,
  Tabs,
  Tab,
  Switch,
  FormGroup,
} from "@mui/material";

import {
  addEmployee,
  getNewSubscriptionReachageDetails,
  updateEmployee,
} from "./appoinmentDashboardApi";
import { payloadDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { getDataRechageDetail } from "./smbAccountRechargeCustomApiHandler";
import { getMonthDifference } from "./smbAccounrReachargeDateFunction";
import CloseIcon from "@mui/icons-material/Close";
import { getAlldetailSerice } from "../services/servicesListApi";

// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { validationPersonalInfo } from "../payment/validation";
import Swal from "sweetalert2";
import ImageUploader from "../../common/imageUpload";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import {
  UpdateProfile,
  addProfile,
  getGusinessProfile,
} from "./busnessProfileModalapi";
import { ModalHeader } from "../../common/modalHeader";
// import { getAlldetailSerice } from "../services/servicesListApi";
// .
import BusinessProfilePDFView from "./BusinessProfilePDFView";
import { useRef } from "react";
import html2pdf from "html2pdf.js";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function BusinessProfileModal({
  open,
  setOpen,
  modalData,
  getAll,
  config,
}) {
  const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [subscription, setSubscription] = useState();
  const [value, setValue] = React.useState("personalInfo");
  const [searchModal, setSearchModal] = useState(false);
  const [cardValue, setCardValue] = useState(null);

  // .
  const pdfRef = useRef();
  const handleChange_Tab = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };

  const onClose = () => {
    setOpen(false);
  };
  const [search, setSearchvalue] = useState("");

  const appnType = useSelector((state) => state.reducer.apppoinmentUerType);
  const dispatch = useDispatch();
  const info = useSelector((state) => state.reducer.detail);
  const [formData, setFormData] = useState(null);
  const userDetail = useSelector((state) => state.reducer.userDetail);

  useEffect(() => {}, [formData]);
  const [dateValue, setDateValue] = useState();
  const [dateValuet, setDateValuet] = useState();

  const [timeValue, setTimeValue] = useState(dayjs());
  const [otpEnabled, setOtpEnabled] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const regex = /^[a-zA-Z\s]*$/;

    if (name == "employeeName" && !regex.test(value)) {
      setFormData({
        ...formData,
        [name]: value[0],
      });
    } else if (name === "mobileNumber") {
     
      if (/^\d{0,10}$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (typeof value == "object") {
      setFormData({
        ...formData,
        [name]: value[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const setDate = (newValue) => {
    setDateValue(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    setFormData((prev) => {
      return { ...prev, doj: date };
      // return {...prev,date:date}
    });
  };

  const setDatet = (newValue) => {
    setDateValuet(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    setFormData((prev) => {
      return { ...prev, dob: date };
      // return {...prev,date:date}
    });
  };

  const setTime = (newValue) => {
    setFormData((prev) => {
      if (newValue["$H"] == 20) {
        prev.hour = newValue["$H"] + 12;
      } else {
        prev.hour = newValue["$H"];
      }
      prev.minute = newValue["$m"];
      return { ...prev };
    });
    setTimeValue(newValue);
  };

  const handleTagsChange = (e) => {
    const { value } = e.target;

    setFormData({
      ...formData,
      service: value,
    });
  };

  const gender = (e) => {
    setFormData((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };
  const [tabVale, setTabValue] = useState("salary");
  const tabFn = (e) => {
    setTabValue(e.target.value);
  };
  const handleVerifymobileNumber = () => {
    if (formData.mobileNumber) {
      setOtpEnabled(true);
    }
  };

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const formDataobj = new FormData();
    Object.keys(formData).forEach((key, index) => {
      formDataobj.append(key, formData[key]);
    });
    const condition = appnType == "profile";

    if (!formData?.id) {
      // addEmployee(payload, () => {
      //   setOpen(false);
      //   getAll();

      // });
      addProfile(formDataobj, (res) => {
        console.log("res update", res);
      });
    } else {
      // payload["id"] = modalData?.id;
      UpdateProfile(formDataobj, (res) => {
        console.log("res update", res);
      });
      // updateEmployee(payload, () => {

      //   setOpen(false);
      //   getAll();
      // });
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [validationMsgFlag, setValidationMsgFlag] = useState(null);

  useEffect(() => {
    setFormData({
      ...formData,
      billerId: info.billerId,
    });
    setDate(timeValue);
    setTime(timeValue);
    gender("male");
  }, []);

  const infoD = useSelector((state) => state.reducer.detail);
  useEffect(() => {
    // getAlldetailSerice(
    //   {
    //     billerId: infoD?.billerId,
    //   },
    //   (res) => {
    //     setservicesArr(res?.data);
    //   }
    // );
  }, []);
  useEffect(() => {
    if (open === true) {
      console.log("getGusinessProfile", userDetail?.myBusinessId);

      getGusinessProfile(userDetail, (res) => {
        console.log("getGusinessProfile", res?.data?.data);
        setFormData({ ...formData, ...res?.data?.data });
      });

      // setFormData({
      //   ...formData,

      //   id: modalData?.id,
      //   bankName: modalData?.bankName,
      //   bankAccountNumber: modalData?.bankAccountNumber,
      //   bankBranch: modalData?.bankBranch,
      //   employeeId: modalData?.employeeId,
      //   employeeName: modalData?.name,
      //   alternateMobileNumber: modalData?.alternateMobile,
      //   // customerName:modalData?.customerName,
      //   mobileNumber: modalData?.mobile,
      //   designation: modalData?.designation,
      //   pan: modalData?.pan,
      //   salary: modalData?.salary,
      //   ifsc: modalData?.ifsc,
      //   address: modalData?.address,
      //   paymentPercentage: modalData?.paymentPercentage
      //     ? String(modalData?.paymentPercentage)
      //     : "",
      //   // otp: "",
      //   dob: modalData?.dob,
      //   doj: modalData?.doj,
      //   deduction: modalData?.deduction,
      //   email: modalData?.email,
      //   aadhar: modalData?.aadhar,
      //   gender: modalData?.gender,
      //   grade: modalData?.grade,
      //   service: "",

      //   date: "",
      //   hour: "",
      //   minute: "",
      //   isActive: modalData?.isActive,
      // });
      // setSearchvalue({name:modalData?.name,id:modalData?.id})
      // setDateValue(dayjs(modalData?.dob));
      // setDateValuet(dayjs(modalData?.doj));

      // setDateValuet()
      // getDataRechageDetail(getNewSubscriptionReachageDetails, setSubscription);
    } else {
      if (!validationMsgFlag) {
        setFormData(null);
      }
    }
  }, [open]);

// ...........Share
  const handleShare = async () => {
    const element = pdfRef.current;
    const generateFileName = () => {
      const now = new Date();

      const day = now.getDate().toString().padStart(2, "0");
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[now.getMonth()];
      const year = now.getFullYear();

      let hours = now.getHours();
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");

      const isPM = hours >= 12;
      const ampm = isPM ? "pm" : "am";
      hours = hours % 12 || 12; // convert to 12-hour format
      const hourStr = hours.toString().padStart(2, "0");

      return `BusinessProfile${day}-${month}-${year}_${hourStr}-${minutes}-${seconds}_${ampm}.pdf`;
    };

    const fileName = generateFileName();
    const options = {
      margin: 0.5,
      fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf()
        .from(element)
        .set(options)
        .output("blob");

      const file = new File([pdfBlob], fileName, {
        type: "application/pdf",
      });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: "Business Profile",
          text: "Check out our business profile!",
          files: [file],
        });
      } else {
        alert("Sharing not supported on this device. Downloading instead.");
        const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "business-profile.pdf";
        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error("PDF share error", err);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "10%",

          left: { xs: "2%", sm: "15%", md: "25%", lg: "30%", xl: "35%" },

          // transform: "translate(-50%, -50%)",
          width: { xs: "95%", sm: "80%", md: "60%", lg: "40%", xl: "30%" },

          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          overflowY: "auto",
        }}
      >
        <ModalHeader
          title="Share Business Profile"
          onClose={(data) => {
            setOpen(data);
          }}
        />

        <Box sx={{ padding: "10px" }} display="flex" justifyContent="center">
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={2}
              sx={{ height: "60vh", paddingX: "10px", overflow: "auto" }}
            >
              <React.Fragment>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Enterprice Name"
                      name="enterpriseName"
                      value={formData?.enterpriseName}
                      onChange={handleChange}
                      required
                      size="small"
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                        shrink: !!formData?.enterpriseName,
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Address"
                      name="address"
                      value={formData?.address}
                      onChange={handleChange}
                      required
                      size="small"
                      InputLabelProps={{
                        className: "mulish",
                        shrink: !!formData?.address,
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Mobile Number"
                      name="mobileNumber"
                      value={formData?.mobileNumber}
                      onChange={handleChange}
                      required
                      size="small"
                      InputLabelProps={{
                        shrink: !!formData?.mobileNumber,
                        className: "mulish",
                        // shrink: !!formData?.mobileNumber,
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        classes: {
                          input: "mulish",
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        },
                      }}
                      helperText={
                        !!formData?.mobileNumber &&
                        formData.mobileNumber.length > 0 &&
                        formData.mobileNumber.length !== 10
                          ? "Mobile number must be 10 digits"
                          : ""
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Email Id"
                      name="emailId"
                      value={formData?.emailId}
                      onChange={handleChange}
                      required
                      size="small"
                      InputLabelProps={{
                        className: "mulish",
                        shrink: !!formData?.emailId,
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        classes: {
                          input: "mulish",
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Specialization"
                      name="specialization"
                      value={formData?.specialization}
                      onChange={handleChange}
                      required
                      multiline
                      rows={5}
                      InputLabelProps={{
                        className: "mulish",
                        shrink: !!formData?.specialization,
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        classes: {
                          input: "mulish",
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Achievements"
                      name="achievements"
                      value={formData?.achievements}
                      onChange={handleChange}
                      required
                      multiline
                      rows={5}
                      InputLabelProps={{
                        className: "mulish",
                        shrink: !!formData?.achievements,
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Overview"
                      name="overview"
                      value={formData?.overview}
                      onChange={handleChange}
                      required
                      multiline
                      rows={5}
                      InputLabelProps={{
                        className: "mulish",
                        shrink: !!formData?.overview,
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Terms And Conditions"
                      name="termsAndConditions"
                      value={formData?.termsAndConditions}
                      onChange={handleChange}
                      required
                      multiline
                      rows={5}
                      InputLabelProps={{
                        className: "mulish",
                        shrink: !!formData?.termsAndConditions,
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
              </React.Fragment>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: "4px" }}>
              <Grid
                item
                xs={12}
                sx={{
                  borderTop: "2px solid #01008B",
                  marginLeft: "15px",
                  marginTop: "8px !important",
                  paddingTop: "4px !important",
                }}
              ></Grid>
              <Grid
                item
                xs={config?.share ? 6 : 12}
                sx={{ display: "flex", justifyContent: "end" }}
              >
                <Button
                  fullWidth
                  type="submit"
                  size="small"
                  variant="contained"
                  color="primary"
                  sx={{
                    backgroundColor: "#01008B",
                    // padding: "10px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Save
                </Button>
              </Grid>
              {config?.share && (
                <Grid
                  item
                  xs={6}
                  sx={{ display: "flex", justifyContent: "end" }}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={{
                      backgroundColor: "#01008B",
                      padding: "10px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                    onClick={handleShare}
                  >
                    Share
                  </Button>
                </Grid>
              )}
              <Box sx={{ display: "none" }}>
                <BusinessProfilePDFView ref={pdfRef} data={formData} />
              </Box>
            </Grid>
          </form>
        </Box>
      </Box>
    </Modal>
  );
}
